import React from "react";
import { Container, Typography, Paper, Box } from "@mui/material";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { Link } from "react-router-dom";
import PageIntro from "../components/pageintro";
import ServicesGridCards from "../components/servicesgrid";
import WhyTecloqCards from "../components/whytecloqcards";
import TransformComponent from "../components/transformcomp";

const transformdata = {
  heading: "Take the next step with Tecloq",
  content:
    "Discover the true power of product development with Tecloq’s cutting-edge React services. Elevate your digital presence and user experience through our expertise and innovation, driving your brand towards unparalleled success.",
};

const whydata = [
  {
    src: "/assets/ProductEngineering/Reactjs/why1.png",
    alt: "why1",
    title: "Unparalleled Code Quality",
    description:
      "When it comes to your mobile or web application code, our developers uphold an unwavering commitment to quality. Following both industry standards and our React development company’s best practices, we deliver a foundation you can rely on.",
  },
  {
    src: "/assets/ProductEngineering/Reactjs/why2.png",
    alt: "why2",
    title: "Efficient Project Management",
    description:
      "Certified PMs and Scrum Masters lead the charge in orchestrating seamless software development. Our team’s expertise ensures a well-coordinated process that keeps the technical team informed, motivated, and primed for effective communication.",
  },
  {
    src: "/assets/ProductEngineering/Reactjs/why3.png",
    alt: "why3",
    title: "Tailored Innovation",
    description:
      "We believe that one size doesn’t fit all. We understand that each business is unique. That’s why we tailor our React solutions to precisely align with your vision, objectives, and industry landscape.",
  },
];

const offeringData = [
  {
    src: "/assets/ProductEngineering/Reactjs/rs1.png",
    alt: "text analysis",
    imgWidth: "70%",
    paddingTop: "3%",
    text: "PWA Development",
  },
  {
    src: "/assets/ProductEngineering/Reactjs/rs2.png",
    alt: "text analysis",
    imgWidth: "65%",
    paddingTop: "3%",
    text: "Full-stack Development",
  },
  {
    src: "/assets/ProductEngineering/Reactjs/rs3.png",
    alt: "text analysis",
    imgWidth: "70%",
    paddingTop: "1%",
    text: "Hybrid App Development",
  },
  {
    src: "/assets/ProductEngineering/Reactjs/rs4.png",
    alt: "text analysis",
    imgWidth: "50%",
    paddingTop: "8%",
    text: "Strategic React Consultant",
  },
  {
    src: "/assets/ProductEngineering/Reactjs/rs5.gif",
    alt: "text analysis",
    imgWidth: "50%",
    paddingTop: "8%",
    text: "React Migration",
  },
];

const ReactPage = () => {
  return (
    <Box sx={{ display: "flex", flexDirection: "column", overflow: "hidden" }}>
      <PageIntro
        bg={"/assets/AdvancedAI/TextAnalysis/background.webp"}
        subheading={"Creating dynamic web experiences through Tecloq’s"}
        heading={"React JS Development Services"}
        desc={"Enhance performance, elevate design."}
      />

      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          margin: "5%",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Typography
          sx={{
            fontFamily: "Orbitron",
            fontWeight: "800",
            fontSize: { xs: "24px", sm: "32px", md: "40px" },
            color: "#000000",
            lineHeight: "120%",
            letterSpacing: "2%",
            display: "flex",
            justifyContent: "center",
            paddingBottom: "1%",
            textAlign: "center",
          }}
        >
          Transforming Web Experiences with Expert React JS Development
        </Typography>
        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", md: "row" },
            margin: "2%",
            gap: { xs: "16px", md: "40px" },
            alignItems: "center",
          }}
        >
          <Typography
            sx={{
              fontFamily: "Inter",
              fontSize: { xs: "14px", sm: "16px", md: "18px" },
            }}
          >
            Are you striving to create web applications that stand out in a
            crowded digital landscape? Do you want to ensure that your
            applications are not just visually appealing but also optimized for
            speed, reliability, and user engagement? Tecloq recognizes the
            challenges you face in meeting these goals while navigating the
            complexities of modern web development.
            <ul>
              {[
                {
                  title: "Empowering Web Solutions:",
                  description:
                    "With expertise in PWAs and React Native, we eliminate load delays, awkward interactions, and outdated interfaces. Our MERN solutions also amplify your app’s brilliance in the digital landscape.",
                },
                {
                  title: "Expedited Time-to-Market:",
                  description:
                    "We accelerate delivery, minimizing roadblocks and resource drain, enhancing productivity to get your product to market faster with our React.js development services.",
                },
                {
                  title: "Cost-Effective Excellence:",
                  description:
                    "Through component-based development and powerful tools, we optimize costs while delivering high-quality results, meeting tight timelines and budget constraints.",
                },
              ].map((item, index) => (
                <li key={index}>
                  <Typography
                    component="h3"
                    sx={{
                      fontFamily: "Orbitron",
                      fontSize: { xs: "16px", sm: "20px", md: "24px" },
                      fontWeight: "700",
                      color: "#FFFFF",
                      marginBottom: "4px",
                    }}
                  >
                    {item.title}
                  </Typography>
                  <Typography
                    sx={{
                      fontFamily: "Inter",
                      fontSize: { xs: "14px", sm: "16px", md: "18px" },
                      color: "#000",
                      lineHeight: "150%",
                    }}
                  >
                    {item.description}
                  </Typography>
                </li>
              ))}
            </ul>
          </Typography>
          <Box
            component="img"
            src="/assets/ProductEngineering/Reactjs/r1.png"
            alt="Python Development"
            sx={{
              width: { xs: "80%", sm: "60%", md: "40%" }, // Responsive width based on screen size
              height: "auto", // Maintain aspect ratio
              maxWidth: "100%", // Ensure it doesn't exceed container width
            }}
          />
        </Box>
      </Box>

      <Box
        sx={{
          maxWidth: "100%",
          height: "auto",
          margin: { xs: "5% 4% 0 4%", md: "8% 8% 0 8%" },
        }}
      >
        <Typography
          sx={{
            fontFamily: "Orbitron",
            fontWeight: "800",
            fontSize: { xs: "24px", sm: "32px", md: "40px" },
            color: "#000000",
            lineHeight: "120%",
            letterSpacing: "2%",
            display: "flex",
            justifyContent: "center",
            paddingBottom: { xs: "2%", md: "3%" },
            textAlign: "center",
          }}
        >
          Our React Development Services
        </Typography>

        <Typography
          sx={{
            fontFamily: "Inter",
            fontWeight: "100",
            fontSize: { xs: "14px", sm: "16px", md: "20px" },
            color: "#000000",
            lineHeight: "150%",
            letterSpacing: "2%",
            display: "flex",
            justifyContent: "center",
            paddingBottom: { xs: "2%", md: "3%" },
            textAlign: "center",
          }}
        >
          Discover the transformative potential of React JS development
          services, guided by expert React developers and consultants. Empower
          your web applications with the prowess of React JS development
          services and consulting. Elevate user experiences, streamline
          operations, and drive business growth with Tecloq. Our comprehensive
          suite of services includes:
        </Typography>
      </Box>

      {/* <ServicesGridCards data={offeringData} /> */}

      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          flexWrap: "wrap",
          gap: { xs: "10px", sm: "20px" },
          "& > :not(style)": {
            m: 1,
            width: { xs: "100%", sm: "47%", md: 400 },
            height: "auto",
          },
        }}
      >
        {[
          {
            src: "/assets/ProductEngineering/Reactjs/rs1.png",
            alt: "text analysis",
            title: "PWA Development",
            imgWidth: "70%",
            paddingTop: "3%",
          },
          {
            src: "/assets/ProductEngineering/Reactjs/rs2.png",
            alt: "text analysis",
            title: "Full-stack Development",
            imgWidth: "65%",
            paddingTop: "3%",
          },
          {
            src: "/assets/ProductEngineering/Reactjs/rs3.png",
            alt: "text analysis",
            title: "Hybrid App Development",
            imgWidth: "70%",
            paddingTop: "1%",
          },
          {
            src: "/assets/ProductEngineering/Reactjs/rs4.png",
            alt: "text analysis",
            title: "Strategic React Consultant",
            imgWidth: "50%",
            paddingTop: "8%",
          },
          {
            src: "/assets/ProductEngineering/Reactjs/rs5.gif",
            alt: "text analysis",
            title: "React Migration",
            imgWidth: "50%",
            paddingTop: "8%",
          },
        ].map((item, index) => (
          <Paper
            key={index}
            elevation={3}
            sx={{
              borderRadius: "5%",
              textAlign: "center",
              padding: "3%",
              alignContent: "center",
            }}
          >
            <img
              src={item.src}
              alt={item.alt}
              loading="lazy"
              style={{
                boxSizing: "border-box",
                width: item.imgWidth,
                height: "auto",
                paddingTop: item.paddingTop,
              }}
            />
            <Typography
              sx={{
                fontFamily: "Inter",
                fontStyle: "normal",
                fontWeight: "700",
                fontSize: { xs: "14px", sm: "16px" },
                lineHeight: "21px",
                textAlign: "center",
                color: "#000000",
                paddingTop: "5%",
              }}
            >
              {item.title}
            </Typography>
          </Paper>
        ))}
      </Box>

      <Box
        sx={{
          maxWidth: "100% !important",
          height: "auto",
          marginTop: "3%",
          padding: { xs: "0 5%", md: "0" },
        }}
      >
        <Typography
          sx={{
            fontFamily: "Orbitron",
            fontWeight: "800",
            fontSize: { xs: "24px", md: "40px" },
            color: "#000000",
            lineHeight: "120%",
            letterSpacing: "2%",
            display: "flex",
            justifyContent: "center",
            paddingBottom: "1%",
            textAlign: "center",
          }}
        >
          Exploring the Brilliance of React JS Development Services
        </Typography>

        <Typography
          sx={{
            fontFamily: "Inter",
            fontWeight: "800",
            fontSize: { xs: "18px", md: "25px" },
            color: "#000000",
            display: "flex",
            justifyContent: "center",
            margin: { xs: "2% 5%", md: "1% 10% 0%" },
            textAlign: "center",
          }}
        >
          What Makes React Exceptional?
        </Typography>

        <Typography
          sx={{
            fontFamily: "Inter",
            fontWeight: "lighter",
            fontSize: { xs: "14px", md: "20px" },
            color: "#000000",
            display: "flex",
            justifyContent: "center",
            margin: { xs: "2% 5%", md: "1% 10% 0%" },
            textAlign: "center",
          }}
        >
          Crafted with mastery, React JS development services epitomize
          exceptional architecture and code quality, propelling your digital
          ventures to new heights.
        </Typography>
      </Box>

      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          flexWrap: "wrap",
          gap: "1%",
        }}
      >
        {[
          {
            title: "Cross-Platform Brilliance",
            description:
              "Elevate your application's reach with React's cross-platform prowess. React developers can harness JavaScript components to craft native apps across iOS and Android, sharing up to 90% of the code between platforms. Embrace efficiency and consistency in your development journey.",
          },
          {
            title: "Simple and Reusable",
            description:
              "For React developers, code reusability spans web and mobile, while JavaScript's versatility streamlines hybrid app rendering. Additionally, the React ecosystem empowers developers to craft complex applications for Android and iOS using native UI elements, platform APIs, and design patterns.",
          },
          {
            title: "Fueling Efficiency",
            description:
              "As an open-source marvel, React thrives on a rich ecosystem, extensive libraries, active community support, and unrivaled responsiveness. Lightning-fast processing speeds enhance user experiences, making React a favored choice for crafting successful mobile and web applications.",
          },
          {
            title: "Championed by Titans",
            description:
              "Witness React's prowess as it fuels the endeavors of renowned industry giants. If React empowers industry leaders, it's poised to propel your aspirations towards unprecedented success. Experience the remarkable possibilities of React JS development services – where excellence meets innovation.",
          },
        ].map((item, index) => (
          <Paper
            key={index}
            elevation={3}
            sx={{
              width: { xs: "90%", md: 600 },
              padding: "2%",
              boxShadow: "none",
              display: "flex",
              alignItems: "flex-start",
              gap: "16px",
            }}
          >
            <img
              src="/assets/BigData/DataLake/charm_circle-tick.png"
              alt={`why${index + 1}`}
              style={{
                width: "10%",
                height: "10%",
                verticalAlign: "bottom",
              }}
            />
            <Box>
              <Typography
                sx={{
                  fontFamily: "Inter",
                  fontWeight: "bold",
                  fontSize: { xs: "18px", md: "20px" },
                  lineHeight: "120%",
                  color: "#000",
                }}
              >
                {item.title}
              </Typography>
              <Typography
                sx={{
                  fontFamily: "Inter",
                  fontWeight: "normal",
                  fontSize: { xs: "14px", md: "16px" },
                  lineHeight: "140%",
                  color: "#000",
                  paddingTop: "3%",
                  textAlign: "left",
                }}
              >
                {item.description}
              </Typography>
            </Box>
          </Paper>
        ))}
      </Box>
      <Box
        sx={{
          maxWidth: "100% !important",
          height: "auto",
          marginTop: { xs: "4%", md: "6%" }, // Smaller margin for mobile
          paddingX: { xs: "5%", md: "0%" }, // Add horizontal padding on mobile
        }}
      >
        <Typography
          sx={{
            fontFamily: "Orbitron",
            fontWeight: "800",
            fontSize: { xs: "24px", md: "40px" }, // Adjust font size for mobile
            color: "#000000",
            lineHeight: "120%",
            letterSpacing: "2%",
            display: "flex",
            justifyContent: "center",
            paddingBottom: { xs: "2%", md: "3%" }, // Adjust padding for mobile
            textAlign: "center", // Ensure center alignment on all screens
          }}
        >
          The Tecloq Advantage
        </Typography>
        <Typography
          sx={{
            fontFamily: "Inter",
            fontWeight: "100",
            fontSize: { xs: "14px", md: "20px" }, // Adjust font size for mobile
            color: "#000000",
            lineHeight: "120%",
            letterSpacing: "2%",
            display: "flex",
            justifyContent: "center",
            paddingBottom: { xs: "2%", md: "3%" },
            textAlign: "center", // Keep text centered on all screens
          }}
        >
          At Tecloq, our competitive edge in software development services is
          driven by exceptional attributes that set us apart.
        </Typography>
      </Box>

      <WhyTecloqCards data={whydata} />

      <TransformComponent data={transformdata} />
    </Box>
  );
};

export default ReactPage;
